export default "__VITE_ASSET__CagbHrx6__"